import { Toaster } from "@/components/ui/toaster";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { UploadProvider } from "./contexts/UploadContext";
import { NavigationStackProvider } from "@/contexts/NavigationStackContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { WidgetLayoutProvider } from "@/contexts/WidgetLayoutContext";
import { ConsultingModeProvider } from "@/contexts/ConsultingModeContext";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Beratung from "./pages/Beratung";
import { KundenViewStandalone } from "./components/beratung/KundenViewStandalone";
import { KundenViewPublic } from "./components/beratung/KundenViewPublic";
import PublicBooking from "./pages/PublicBooking";
const App = () => (
  <AuthProvider>
    <UploadProvider>
      <NavigationStackProvider>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
          <TooltipProvider delayDuration={300}>
            <WidgetLayoutProvider>
              <ConsultingModeProvider>
                <BrowserRouter>
                  <div className="glassmorphism-bg" aria-hidden="true" />
                  <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/beratung" element={<Beratung />} />
                    <Route path="/beratung/:sessionId" element={<Beratung />} />
                    <Route path="/beratung/:sessionId/kunden-view" element={<KundenViewStandalone />} />
                    <Route path="/beratung-teilnehmen/:token" element={<KundenViewPublic />} />
                    <Route path="/book/:token" element={<PublicBooking />} />
                    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </BrowserRouter>
                <Toaster />
              </ConsultingModeProvider>
            </WidgetLayoutProvider>
          </TooltipProvider>
        </ThemeProvider>
      </NavigationStackProvider>
    </UploadProvider>
  </AuthProvider>
);

export default App;
